import React from "react";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Icon
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";

class chatCard extends React.Component {
  componentDidMount() {
    this.props.updatePs();
  }
  render() {
    return (
      <GridItem
        xs={12}
        sm={10}
        md={6}
        style={
          this.props.ownMessage
            ? { float: "right", marginBottom: "25px", width: "100%" }
            : { marginBottom: "25px", width: "100%" }
        }
      >
        <Card
          style={
            this.props.ownMessage
              ? { backgroundColor: "#EDEBF5" }
              : { backgroundColor: "#EBEAEE" }
          }
        >
          <CardContent>
            <div
              style={{
                display: "flex",
                paddingBottom: "15px",
                borderBottom: "1px solid #bbbbbb80",
                position: "relative"
              }}
            >
              {this.props.addTodo ? (
                <div>
                  <IconButton
                    style={{
                      position: "absolute",
                      right: "-25px",
                      top: "-25px"
                    }}
                    onClick={this.props.addTodo}
                  >
                    <Icon fontSize="small">playlist_add</Icon>
                  </IconButton>
                </div>
              ) : null}
              <img
                className="avatarImg"
                src={this.props.avatarPath}
                alt="..."
                style={{
                  width: "30px",
                  height: "30px",
                  margin: "0px",
                  marginRight: "15px"
                }}
              />
              <Typography variant="body2">{this.props.name}</Typography>

              {this.props.date ? (
                <Typography
                  variant="caption"
                  style={{ position: "absolute", right: "0px", bottom: "5px" }}
                >
                  {this.props.date}
                </Typography>
              ) : null}
            </div>
            <div style={{ marginTop: "10px" }}>
              <Typography variant="body1">{this.props.text}</Typography>
            </div>
          </CardContent>
        </Card>
      </GridItem>
    );
  }
}
export default chatCard;



// WEBPACK FOOTER //
// ./src/components/ChatCard/ChatCard.jsx